/*
 * class name defined on the Backend
 */
export enum FavoriteType {
  NOTEBOOK = 'Notebook',
  REPORT = 'Report',
}

export interface Favorite {
  uid?: string;
  class_name: string;
  obj_id: number;
  obj_uid?: string;
  item?: any;  // this can be report
}
